import React from 'react';
import { withTranslation } from 'react-i18next';
import EnvironmentalRisk from '../Inventory/InventoryDetails/EnvironmentalInformation/EnvironmentalRisk';
import Risk from '../Inventory/InventoryDetails/Risk';

class BRisksContainer extends React.PureComponent {
  render() {
    return this.getContainerBody();
  }

  getContainerBody = () => {
    const { values } = this.props;
    let initialEnvRiskResultDto = {
      envRisk: values.maxEnvRisk,
      envRiskLevel: values.maxEnvRiskLevel
    };

    return (
      <>
        <EnvironmentalRisk
          {...this.props}
          initialEnvRiskResultDto={initialEnvRiskResultDto}
          labelPrefix="max."
        />
        <Risk
          id="buildingRisk"
          label="building.is.opam"
          display={values.location.isOpam}
          levelColor="#ff0000"
        />
      </>
    );
  };
}

export default withTranslation()(BRisksContainer);
